import { ActionType } from '../../controllers/ActionsGenerator';
import { FooterType } from '../../controllers/FooterGenerator';
import { InsurancePageName } from '../../helpers/insuranceHelpers';
import { therapySchema } from './extendedTherapySchema';

export const psychiatrySchema = (routedFromProfilePage: boolean, t, session) => {
    const therapySchemaMap = therapySchema(routedFromProfilePage, t, session);
    return {
        ...therapySchemaMap,
        [InsurancePageName.InsuranceApproved]: {
            ...therapySchemaMap[InsurancePageName.InsuranceApproved],
            heading: t('insuranceForm:insurance_approved.pamm.page_title'),
            actionSchema: [
                therapySchemaMap[InsurancePageName.InsuranceApproved].actionSchema[0],
                {
                    title: t('insuranceForm:insurance_approved.pamm.request_provider'),
                    onClick: ActionType.GO_REQUEST_PSYCH,
                },
            ],
            footer: FooterType.SMALL_TEXT,
        },
        [InsurancePageName.InsuranceIneligible]: {
            ...therapySchemaMap[InsurancePageName.InsuranceIneligible],
            heading: t('insuranceForm:insurance_ineligible.pamm.title'),
            actionSchema: [
                {
                    title: t(
                        routedFromProfilePage
                            ? 'translation:common.backToProfile'
                            : 'insuranceForm:insurance_ineligible.pamm.back',
                    ),
                    onClick: ActionType.GO_HOME_OR_PROFILE,
                },
                {
                    title: t('insuranceForm:insurance_ineligible.pamm.explore_care'),
                    onClick: ActionType.GO_RESOURCES,
                },
            ],
            footer: FooterType.INELIGIBLE_SMALL_TEXT,
        },
        [InsurancePageName.InsuranceInactive]: {
            ...therapySchemaMap[InsurancePageName.InsuranceInactive],
            heading: t('insuranceForm:insurance_inactive.pamm.title'),
            actionSchema: [
                therapySchemaMap[InsurancePageName.InsuranceInactive].actionSchema[2],
                {
                    title: t('insuranceForm:insurance_inactive.pamm.try_again'),
                    onClick: ActionType.GO_INSURANCE_FORM,
                },
            ],
            footer: FooterType.INELIGIBLE_SMALL_TEXT,
        },
    };
};
